import store from '@store'
import UserFlagsService from '@services/resources/UserFlagsService'
import PermissionHelper from '../utils/permissionHelper'
import {AccessLevel} from "@views/configurations/enums/accessLevel";

// Instância do helper de permissões
const canAccessScreen = (screenName, level = AccessLevel.READER) =>
  new PermissionHelper(store).canAccessScreen(screenName, level)

export default [
  {
    path: '/operations',
    name: 'operations',
    component: () => lazyLoadView(import('@views/operations')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {

        if (store.getters.isAuthenticated && (canAccessScreen('operations') || canAccessScreen('operations_viewer'))) {
          next()
        } else {
          next({
            name: 'dashboard',
          })
        }
      },
    },

  },
  {
    path: '/',
    name: 'home',
    component: () => lazyLoadView(import('@views/home')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters.isAuthenticated) {
          // Redirect to the home page instead
          window.location.href = 'dashboard'
        } else {
          // Continue to the login page
          next({
            name: 'login',
          })
        }
      },
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => lazyLoadView(import('@views/dashboard')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters.isAuthenticated) {
          // Redirect to the home page instead
          next()
          // redirecionando da dash para saques // router ou next nao funciona aqui
          // window.location.href = 'dashboard'
          // if (user) {
          //   redirectTo(user)
          // }
        } else {
          // Continue to the login page
          next({
            name: 'login',
          })
        }
      },
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },

  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters.isAuthenticated) {
          // Redirect to the home page instead
          next({
            name: 'dashboard',
          })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/codigo-de-acesso',
    name: 'codigo-de-acesso',
    component: () => lazyLoadView(import('@layouts/security/AccessCode')),
    props: route => {
      const email = route.query.email;
      // Basic format validation
      if (!email || typeof email !== 'string' || !email.includes('@')) {
        return { email: '' };
      }
      return { email: email.trim() };
    },
    beforeEnter: (to, from, next) => {
      const hasPermission = !!sessionStorage.getItem('allow_access_code');
      if (hasPermission) {
        next();
      } else {
        next('/');
      }
    }
  },
  {
    path: '/register',
    name: 'register',
    component: () => lazyLoadView(import('@views/register')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({
            name: 'dashboard',
          })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/confirm-account',
    name: 'confirm-account',
    component: () => lazyLoadView(import('@views/confirm')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({
            name: 'dashboard',
          })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/forget-password',
    name: 'forget-password',
    component: () => lazyLoadView(import('@views/forgetPassword')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({
            name: 'dashboard',
          })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.meta.authRequired
        )
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute
            ? {
                name: 'dashboard',
              }
            : {
                ...routeFrom,
              }
        )
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('@views/_404').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
  {
    path: '/saques',
    name: 'saques',
    component: () => lazyLoadView(import('@views/withdrawals/view')),
    children: [
      {
        path: '/saques',
        component: () => lazyLoadView(import('@views/withdrawals/list')),
        name: 'Listar Sequências',
      },
    ],
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        // document.cookie = 'user = '
        if (store.getters.isAuthenticated && canAccessScreen('saques')) {
          // Redirect to the home page instead
          next()
        } else {
          store.dispatch('logoutRequest')
          // Continue to the login page
          next({
            name: 'login',
          })
        }
      },
    },
  },
  {
    path: '/saques-agrupados',
    name: 'saques agrupados',
    component: () => lazyLoadView(import('@views/withdrawals/view')),
    children: [
      {
        path: '/saques-agrupados',
        component: () => lazyLoadView(import('@views/withdrawals/listGroup')),
        name: 'Listar Saques Agrupados',
      },
      {
        path: '/review-withdrawal/:id',
        component: () => lazyLoadView(import('@views/withdrawals/new/ReviewWithdrawal')),
        name: 'Análise de Saque',
      },
    ],
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        // document.cookie = 'user = '
        if (store.getters.isAuthenticated && canAccessScreen('saques')) {
          // Redirect to the home page instead
          next()
        } else {
          store.dispatch('logoutRequest')
          // Continue to the login page
          next({
            name: 'login',
          })
        }
      },
    },
  },
  {
    path: '/saques-agrupados-x-grow',
    name: 'saques agrupados x-grow',
    component: () => lazyLoadView(import('@views/withdrawals/x-grow/view')),
    children: [
      {
        path: '/saques-agrupados-x-grow',
        component: () => lazyLoadView(import('@views/withdrawals/x-grow/listGroup')),
        name: 'Listar Saques Agrupados X-GROW',
      },
      {
        path: '/review-withdrawal-x-grow/:id',
        component: () => lazyLoadView(import('@views/withdrawals/x-grow/new/ReviewWithdrawal')),
        name: 'Análise de Saque X-GROW',
      },
    ],
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        // document.cookie = 'user = '
        if (store.getters.isAuthenticated && canAccessScreen('xGrow')) {
          // Redirect to the home page instead
          next()
        } else {
          store.dispatch('logoutRequest')
          // Continue to the login page
          next({
            name: 'login',
          })
        }
      },
    },
  },
  {
    path: '/clientes',
    component: () => lazyLoadView(import('@views/users/view')),
    children: [
      {
        path: '/clientes',
        component: () => lazyLoadView(import('@views/users/list')),
        name: 'Listar Clientes',
      },
    ],
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (
          store.getters.isAuthenticated &&
          canAccessScreen('clientes')
        ) {
          // Redirect to the home page instead
          next()
        } else {
          store.dispatch('logoutRequest')
          // Continue to the login page
          next({
            name: 'login',
          })
        }
      },
    },
  },
  {
    path: '/reembolsos',
    component: () => lazyLoadView(import('@views/refunds/view')),
    children: [
      {
        path: '/reembolsos',
        component: () => lazyLoadView(import('@views/refunds/list')),
        name: 'Listar solicitações de reembolso',
      },
    ],
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters.isAuthenticated && canAccessScreen('reembolsos')) {
          // Redirect to the home page instead
          next()
        } else {
          store.dispatch('logoutRequest')
          // Continue to the login page
          next({
            name: 'login',
          })
        }
      },
    },
  },
  {
    path: '/vendas',
    component: () => lazyLoadView(import('@views/sales/view')),
    children: [
      {
        path: '/vendas',
        component: () => lazyLoadView(import('@views/sales/list')),
        name: 'Vendas',
      },
    ],
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters.isAuthenticated && canAccessScreen('vendas')) {
          // Redirect to the home page instead
          next()
        } else {
          store.dispatch('logoutRequest')
          // Continue to the login page
          next({
            name: 'login',
          })
        }
      },
    },
  },
  {
    path: '/vendas-next',
    component: () => lazyLoadView(import('@views/sales-next/view')),
    children: [
      {
        path: '/vendas-next',
        component: () => lazyLoadView(import('@views/sales-next/list')),
        name: 'Vendas-Next',
      },
      {
        path: '/vendas-next/:id/details',
        component: () => lazyLoadView(import('@views/sales-next/details')),
        name: 'vendas-details-next',
      },
    ],
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const profile = store.getters.getProfile;

          if (!profile || !profile.id) {
            return next({ path: '/' });
          }

          const userFlagsService = UserFlagsService.build();

          const flags = await userFlagsService.read({ id: profile.id });

          const hasFlag = Array.isArray(flags) && flags.includes('ERP_SALES_MANAGEMENT');

          if (!hasFlag) {
            return next({ path: '/' });
          }
        } catch (error) {
          console.error('Erro ao buscar flags do usuário:', error)
          return next({ path: '/' });
        }

        // If the user is already logged in
        if (store.getters.isAuthenticated && canAccessScreen('vendas')) {
          // Redirect to the home page instead
          return next();
        } else {
          if (store.getters.isAuthenticated) {
            store.dispatch('logoutRequest')
          }
          // Continue to the login page
          return next({
            name: 'login',
          })
        }
      },
    },
  },
  {
    path: '/antecipacao',
    component: () => lazyLoadView(import('@views/anticipation/view')),
    children: [
      {
        path: '/antecipacao',
        component: () => lazyLoadView(import('@views/anticipation/list')),
        name: 'antecipacao',
      },
    ],
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters.isAuthenticated && canAccessScreen('antecipacao')) {
          // Redirect to the home page instead
          next()
        } else {
          store.dispatch('logoutRequest')
          // Continue to the login page
          next({
            name: 'login',
          })
        }
      },
    },
  },

  // {
  //   path: '/extrato',
  //   component: () => lazyLoadView(import('@views/financial_statements/view')),
  //   children: [{
  //     path: '/extrato',
  //     component: () =>
  //       lazyLoadView(import('@views/financial_statements/list')),
  //     name: 'Extrato financeiro',
  //   }, ],
  //   meta: {
  //     beforeResolve(routeTo, routeFrom, next) {
  //       // If the user is already logged in
  //       if (store.getters.isAuthenticated && adminFinancial) {
  //         // Redirect to the home page instead
  //         next()
  //       } else {
  //         store.dispatch('logoutRequest')
  //         // Continue to the login page
  //         next({
  //           name: 'login'
  //         })
  //       }
  //     },
  //   },
  // },
  {
    path: '/produtos',
    component: () => lazyLoadView(import('@views/products/view')),
    children: [
      {
        path: '/produtos',
        component: () => lazyLoadView(import('@views/products/list')),
        name: 'Produtos',
      },
    ],
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters.isAuthenticated && canAccessScreen('produtos')) {
          // Redirect to the home page instead
          next()
        } else {
          // Cookies.remove('access_token');
          // Cookies.remove('user');
          store.dispatch('logoutRequest')
          // Continue to the login page
          next({
            name: 'login',
          })
        }
      },
    },
  },
  {
    path: '/cashback',
    component: () => lazyLoadView(import('@views/cashback/view')),
    children: [
      {
        path: '/cashback',
        component: () => lazyLoadView(import('@views/cashback/list')),
        name: 'Cashback',
      },
    ],
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters.isAuthenticated && canAccessScreen('cashback')) {
          // Redirect to the home page instead
          next()
        } else {
          // Cookies.remove('access_token');
          // Cookies.remove('user');
          store.dispatch('logoutRequest')
          // Continue to the login page
          next({
            name: 'login',
          })
        }
      },
    },
  },
  {
    path: '/chargebacks',
    component: () => lazyLoadView(import('@views/chargebacks/view')),
    children: [
      {
        path: '/chargebacks',
        component: () => lazyLoadView(import('@views/chargebacks/list')),
        name: 'chargebacks',
      },
    ],
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters.isAuthenticated && canAccessScreen('chargebacks')) {
          // Redirect to the home page instead
          next()
        } else {
          store.dispatch('logoutRequest')
          // Continue to the login page
          next({
            name: 'login',
          })
        }
      },
    },
  },
  {
    path: '/requisicoes',
    component: () => lazyLoadView(import('@views/requests/view')),
    children: [
      {
        path: '/requisicoes',
        component: () => lazyLoadView(import('@views/requests/list')),
        name: 'Requisições',
      },
    ],
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters.isAuthenticated && canAccessScreen('requisicoes')) {
          // Redirect to the home page instead
          next()
        } else {
          store.dispatch('logoutRequest')
          // Continue to the login page
          next({
            name: 'login',
          })
        }
      },
    },
  },
  {
    path: '/conciliacao-vendas',
    component: () => lazyLoadView(import('@views/reconcile/view-vendas')),
    children: [
      {
        path: '/conciliacao-vendas',
        component: () => lazyLoadView(import('@views/reconcile/list-vendas')),
        name: 'Conciliacao Vendas',
      },
    ],
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters.isAuthenticated && canAccessScreen('conciliacaoVendas')) {
          // Redirect to the home page instead
          next()
        } else {
          store.dispatch('logoutRequest')
          // Continue to the login page
          next({
            name: 'login',
          })
        }
      },
    },
  },
  {
    path: '/conciliacao-assinatura',
    component: () => lazyLoadView(import('@views/reconcile/view-assinatura')),
    children: [
      {
        path: '/conciliacao-assinatura',
        component: () =>
          lazyLoadView(import('@views/reconcile/list-assinatura')),
        name: 'Conciliacao Assinatura',
      },
    ],
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters.isAuthenticated && canAccessScreen('conciliacaoAssinatura')) {
          // Redirect to the home page instead
          next()
        } else {
          store.dispatch('logoutRequest')
          // Continue to the login page
          next({
            name: 'login',
          })
        }
      },
    },
  },

  {
    path: '/revisao-documentos',
    component: () =>
      lazyLoadView(import('@views/document_review/view-documentos')),
    children: [
      {
        path: '/revisao-documentos',
        component: () =>
          lazyLoadView(import('@views/document_review/list-documentos')),
        name: 'Revisão de Documentos',
      },
    ],
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters.isAuthenticated && canAccessScreen('revisaoDocumentos')) {
          // Redirect to the home page instead
          next()
        } else {
          store.dispatch('logoutRequest')
          // Continue to the login page
          next({
            name: 'login',
          })
        }
      },
    },
  },

  {
    path: '/analises',
    component: () => lazyLoadView(import('@views/analysis/view')),
    children: [
      {
        path: '/analises',
        component: () => lazyLoadView(import('@views/analysis/list')),
        name: 'Análises',
      },
    ],
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters.isAuthenticated && canAccessScreen('analises')) {
          // Redirect to the home page instead
          next()
        } else {
          store.dispatch('logoutRequest')
          // Continue to the login page
          next({
            name: 'login',
          })
        }
      },
    },
  },
  {
    path: '/analises/venda/:id',
    component: () => lazyLoadView(import('@views/analysis/view-analyse')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters.isAuthenticated && canAccessScreen('analises')) {
          // Redirect to the home page instead
          next()
        } else {
          store.dispatch('logoutRequest')
          // Continue to the login page
          next({
            name: 'login',
          })
        }
      },
    },
  },
  {
    path: '/analises/participante/:id',
    props: true,
    component: () =>
      lazyLoadView(import('@views/analysis/view-analyse-seller')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters.isAuthenticated && canAccessScreen('analises')) {
          // Redirect to the home page instead
          next()
        } else {
          store.dispatch('logoutRequest')
          // Continue to the login page
          next({
            name: 'login',
          })
        }
      },
    },
  },
  {
    path: '/identidade',
    component: () => lazyLoadView(import('@views/identity/view')),
    children: [
      {
        path: '/identidade',
        component: () => lazyLoadView(import('@views/identity/list')),
        name: 'Análises',
      },
    ],
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters.isAuthenticated && canAccessScreen('identidade')) {
          // Redirect to the home page instead
          next()
        } else {
          store.dispatch('logoutRequest')
          // Continue to the login page
          next({
            name: 'login',
          })
        }
      },
    },
  },

  {
    path: '/marcos',
    name: 'marcos',
    component: () => lazyLoadView(import('@views/marks/view')),
    children: [
      {
        path: '/marcos',
        component: () => lazyLoadView(import('@views/marks/list')),
        name: 'Marcos atingidos',
      },
    ],
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters.isAuthenticated && canAccessScreen('marcos')) {
          // Redirect to the home page instead
          next()
        } else {
          // Continue to the login page
          next({
            name: 'login',
          })
        }
      },
    },
  },
  {
    path: '/banners',
    name: 'Banners',
    component: () => lazyLoadView(import('@views/banners/view')),
    children: [
      {
        path: '/banners',
        component: () => lazyLoadView(import('@views/banners/list')),
        name: 'Listagem de Banners',
      },
    ],
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (
          store.getters.isAuthenticated &&
          canAccessScreen('banners')
        ) {
          // Redirect to the home page instead
          next()
        } else {
          // Continue to the login page
          next({
            name: 'login',
          })
        }
      },
    },
  },
  {
    path: '/reclamacao',
    component: () => lazyLoadView(import('@views/claim/view')),
    children: [
      {
        path: '/reclamacao',
        component: () => lazyLoadView(import('@views/claim/list')),
        name: 'Reclamações',
      },
    ],
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (
          store.getters.isAuthenticated &&
          canAccessScreen('reclamacao')
        ) {
          // Redirect to the home page instead
          next()
        } else {
          store.dispatch('logoutRequest')
          // Continue to the login page
          next({
            name: 'login',
          })
        }
      },
    },
  },
  {
    path: '/analise-de-venda',
    component: () => lazyLoadView(import('@views/sale_analyse/view')),
    children: [
      {
        path: '/analise-de-venda',
        component: () => lazyLoadView(import('@views/sale_analyse/list')),
        name: 'Análise de Venda',
      },
    ],
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters.isAuthenticated && canAccessScreen('analiseDeVenda')) {
          // Redirect to the home page instead
          next()
        } else {
          store.dispatch('logoutRequest')
          // Continue to the login page
          next({
            name: 'login',
          })
        }
      },
    },
  },
  {
    path: '/recibos/cartoes/:id',
    name: 'ReciboCartoes',
    component: () => ({
      component: import('@views/sales/modals/pdfs/CartoesPdf.vue'),
      loading: () => import('@views/_loading.vue'),
      error: () => import('@views/_timeout.vue'),
      delay: 200,
      timeout: 10000
    })
  },
  {
    path: '/recibos/pix/:id',
    name: 'ReciboPix',
    component: () => ({
      component: import('@views/sales/modals/pdfs/PixPdf.vue'),
      loading: () => import('@views/_loading.vue'),
      error: () => import('@views/_timeout.vue'),
      delay: 200,
      timeout: 10000
    })
  },
  {
    path: '/recibos/boletos/:id',
    name: 'ReciboBoletos',
    component: () => ({
      component: import('@views/sales/modals/pdfs/BoletoPdf.vue'),
      loading: () => import('@views/_loading.vue'),
      error: () => import('@views/_timeout.vue'),
      delay: 200,
      timeout: 10000
    })
  },
  {
    path: '/configurations',
    name: 'configurations',
    component: () => lazyLoadView(import('@views/configurations/view')),
    children: [
      {
        path: '/configurations',
        component: () => lazyLoadView(import('@views/configurations/list')),
        name: 'Listar Configurações',
      },
    ],
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        // document.cookie = 'user = '
        if (store.getters.isAuthenticated && canAccessScreen('configurations')) {
          // Redirect to the home page instead
          next()
        } else {
          store.dispatch('logoutRequest')
          // Continue to the login page
          next({
            name: 'login',
          })
        }
      },
    },
  },
]
// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/_loading').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 200,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
